// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19p7Z","inner":"Footer_inner__2LeKF"};